import { Avatar, Checkbox, ListItem } from '@mui/material';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { Checkmark, CheckmarkChecked } from 'Images';

interface ICityOption {
  option: string;
  isSelected: boolean;
  selectCity: Function;
}

export const CityOption = ({ option, isSelected, selectCity }: ICityOption) => {
  const optionId = option.replace(' ', '-');

  return (
    <ListItem
      sx={{
        maxHeight: '40px',
        fontWeight: isSelected ? '700 !important' : '400 !important',
        fontSize: '18px',
        lineHeight: '22px',
        '&:hover': {
          bgcolor: 'primary.shade_100',
          cursor: 'pointer',
        },
        '&.Mui-selected': {
          fontWeight: '400 !important',
          bgcolor: 'primary.shade_100',
        },
      }}
      onClick={() => (selectCity ? selectCity(option) : undefined)}
      role='option'
      aria-selected={isSelected}
      aria-labelledby={option}
    >
      <label htmlFor={optionId}>
        <Checkbox
          id={optionId}
          aria-labelledby={optionId}
          icon={
            <Avatar
              alt=''
              src={Checkmark}
              sx={{ width: '24px', height: '24px' }}
            />
          }
          checkedIcon={
            <Avatar
              alt=''
              src={CheckmarkChecked}
              sx={{ width: '24px', height: '24px' }}
            />
          }
          checked={isSelected}
        />
        <span id={optionId}>{option}</span>
      </label>
    </ListItem>
  );
};
